<div class="sidebar-container">
    <button class="as-dropdown-toggle" *ngIf="screenSize === 'xs'" (click)="showMobileMenu = !showMobileMenu">
        <img *ngIf="activeMenuItem?.img" class="image-img" src="assets/images/{{ activeMenuItem?.img }}" alt="menu icon" [ngClass]="activeMenuItem?.img" />

        <img *ngIf="activeMenuItem?.icon" class="image-icon" src="assets/images/{{ activeMenuItem?.icon }}" alt="menu icon" [ngClass]="activeMenuItem?.icon" />
        {{ activeMenuItem?.title | translate }}<i class="fa fa-angle-down"></i>
    </button>
    <div class="container-drop-menu">
        <app-select-section
            [userPath]="userPath"
            *ngIf="userPath !== 'file-management' && userPath !== 'periodic-review' && userPath !== 'data-management'"
        ></app-select-section>

        <div *ngIf="userPath === 'file-management'" class="sidebar-container title-container custome-file-container">
            <span>{{ 'fileManagement' | translate }}</span>
        </div>
        <div *ngIf="userPath === 'periodic-review'" class="sidebar-container title-container custome-file-container prediodic">
            <img src="assets/images/Clippathgroup.svg" alt="menu icon" class="image-icon" />
            <span>{{ 'reportsManagement' | translate }}</span>
        </div>
        <div
            *ngIf="userPath === 'admin' || userPath === 'manager' || userPath === 'account-manager' || userPath === 'requester' || userPath === 'employee'"
            class="sidebar-container title-container custome-file-container prediodic mb-3"
        >
            <img src="assets/images/Clippathgroup.svg" alt="menu icon" class="image-icon" />
            <span>{{ 'requests_header' | translate }}</span>
        </div>
        <div *ngIf="userPath === 'data-management'" class="sidebar-container title-container custome-file-container prediodic mb-3">
            <img src="assets/images/Clippathgroup.svg" alt="menu icon" class="image-icon" />
            <span>{{ 'inquirySettings' | translate }}</span>
            <!-- <span  class="contentarrow"><i class="fa fa-angle-left"></i></span> -->
        </div>
        <app-select-section
            [userPath]="userPath"
            *ngIf="userPath !== 'file-management' && userPath !== 'periodic-review' && userPath === 'data-management'"
        ></app-select-section>

        <!-- Regular menu items -->
        <app-sidebar-menu-item
            *ngFor="let menuItem of filteredMenuList"
            [menuItem]="menuItem"
            [activeMenuItem]="activeMenuItem"
            [userPath]="userPath"
            [screenSize]="screenSize"
            [showMobileMenu]="showMobileMenu"
            (showMenu)="showMenufunction($event)"
        >
        </app-sidebar-menu-item>
        <ng-container *ngIf="(userPath === 'admin' || userPath === 'manager' || userPath === 'employee') && callRecordMenuItem.length > 0">
            <div class="sidebar-container title-container custome-file-container prediodic mb-3">
                <img src="assets/images/Clippathgroup.svg" alt="menu icon" class="image-icon" />
                <span>{{ 'callRecord' | translate }}</span>
            </div>
            <app-sidebar-menu-item
                [menuItem]="callRecordMenuItem[0]"
                [activeMenuItem]="activeMenuItem"
                [userPath]="userPath"
                [screenSize]="screenSize"
                [showMobileMenu]="showMobileMenu"
                (showMenu)="showMenufunction($event)"
            >
            </app-sidebar-menu-item>
        </ng-container>
        <ng-container
            *ngIf="
                (userPath === 'admin' || userPath === 'manager' || userPath === 'account-manager' || userPath === 'employee') && dashboardMenuItems.length > 0
            "
        >
            <div class="sidebar-container title-container custome-file-container prediodic mb-3">
                <img src="assets/images/Clippathgroup.svg" alt="menu icon" class="image-icon" />
                <span>{{ 'dashboards' | translate }}</span>
            </div>
            <app-sidebar-menu-item
                *ngFor="let menuItem of dashboardMenuItems"
                [menuItem]="menuItem"
                [activeMenuItem]="activeMenuItem"
                [userPath]="userPath"
                [screenSize]="screenSize"
                [showMobileMenu]="showMobileMenu"
                (showMenu)="showMenufunction($event)"
            >
            </app-sidebar-menu-item>
        </ng-container>
    </div>
    <img
        src="assets/images/imgMenuMan.png"
        *ngIf="screenSize !== 'xs' && userPath !== 'file-management' && userPath !== 'periodic-review'"
        class="img-thumbnai rounded mx-auto d-block"
    />
</div>
